/**
 * Coins in money.
 *
 * The economy is "1 coin = 1 tetri" (DECISIONS 2026-07-18), but every screen
 * that showed a coin balance either left it as a bare number or converted it
 * to dollars — the one currency a Georgian learner does not think in. Nobody
 * could tell what 278 coins was worth (audit F091).
 *
 * 100 tetri = 1 lari, so the conversion is fixed and offline: no FX call, and
 * nothing here depends on the Paddle price.
 */

/** "2.78" — lari, always two decimals, the way money is written. */
export function coinsToGel(coins: number): string {
  return (Math.max(0, coins) / 100).toFixed(2);
}
